import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const TitleMainSecond = props => (
  <div className="container-summary-title-normal top topx2">
    <h2>{props.language.detail_waiting_times.operationIndicator}</h2>
  </div>
);

export default TitleMainSecond;



// WEBPACK FOOTER //
// ./source/client/components/summary_fulfillment/titleMainSecond.jsx